export default {};



// WEBPACK FOOTER //
// ./src/components/wallet/shared/deposit-result/deposit-result.js